import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const HeroSection = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  
  const handleSearch = () => {
    navigate('/properties');
  };

  const handleSecondaryAction = () => {
    if (isAuthenticated) {
      navigate('/add-property');
    } else {
      navigate('/properties');
    }
  };

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, rgba(128, 0, 32, 0.7) 0%, rgba(44, 44, 44, 0.7) 100%), 
                     url('https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80') center/cover no-repeat`,
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        backgroundAttachment: 'fixed',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(45deg, rgba(128, 0, 32, 0.4) 0%, rgba(44, 44, 44, 0.4) 100%)',
          zIndex: 1
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '100px',
          background: 'linear-gradient(to top, rgba(250, 249, 247, 1) 0%, rgba(250, 249, 247, 0) 100%)',
          zIndex: 2
        }
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Box sx={{ color: 'white', maxWidth: '800px', mx: 'auto', textAlign: 'center' }}>
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1.8rem', sm: '2.2rem', md: '3rem' },
              lineHeight: { xs: 1.3, md: 1.2 },
              mb: 2,
              wordBreak: 'break-word',
              hyphens: 'auto',
              maxWidth: '100%'
            }}
          >
            Verified Land. Transparent Deals. Zero Hassle.
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 300,
              fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' },
              mb: 4,
              opacity: 0.9,
              lineHeight: { xs: 1.4, md: 1.3 }
            }}
          >
            Discover the perfect property that matches your lifestyle and budget
          </Typography>
          
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 1.5, sm: 2 }, 
            justifyContent: 'center', 
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            maxWidth: { xs: '300px', sm: 'none' },
            mx: 'auto'
          }}>
            <Button
              variant="contained"
              size="large"
              onClick={handleSearch}
              sx={{
                backgroundColor: '#d4af37', // Gold accent
                color: '#2c2c2c',
                px: { xs: 3, sm: 4 },
                py: { xs: 1.2, sm: 1.5 },
                fontSize: { xs: '1rem', sm: '1.1rem' },
                fontWeight: 600,
                width: { xs: '100%', sm: 'auto' },
                '&:hover': {
                  backgroundColor: '#b8941f',
                }
              }}
            >
              Browse Properties
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={handleSecondaryAction}
              sx={{
                borderColor: '#d4af37 !important', // Gold border to match the first button
                color: '#d4af37 !important', // Gold text
                px: { xs: 3, sm: 4 },
                py: { xs: 1.2, sm: 1.5 },
                fontSize: { xs: '1rem', sm: '1.1rem' },
                fontWeight: '600 !important',
                backgroundColor: 'rgba(212, 175, 55, 0.1) !important',
                width: { xs: '100%', sm: 'auto' },
                '&:hover': {
                  borderColor: '#b8941f !important',
                  backgroundColor: 'rgba(212, 175, 55, 0.2) !important',
                  color: '#b8941f !important',
                },
                '&.MuiButton-root': {
                  color: '#d4af37 !important',
                  borderColor: '#d4af37 !important',
                }
              }}
            >
              {isAuthenticated ? 'List Property' : 'View All Properties'}
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
